<template>
  <div class="tab-pane fade show active" id="trd">
    <!--Loading-->
    <div class="text-center py-5" v-if="userInfo.loading">
      <b-spinner />
    </div>

    <!--Content-->
    <div v-if="!userInfo.loading && userInfo.data">
      <!--You information-->
      <form
        @input.prevent="handleUserInfoFormDataChange"
        @submit.prevent="handleUpdateUserInformation"
        action=""
      >
        <div class="part">
          <!--First name-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              First name
            </p>
            <div class="right-side">
              <input
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                required
                type="text"
                v-model="userInfo.data.firstName"
              />
            </div>
          </div>
          <!--Last name-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Last name
            </p>
            <div class="right-side">
              <input
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                required
                type="text"
                v-model="userInfo.data.lastName"
              />
            </div>
          </div>
          <!--Email address-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">Email</p>
            <div class="right-side">
              <input
                :class="{ 'email-disabled': !isEmailAccount }"
                :disabled="!isEmailAccount"
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                required
                type="email"
                v-model="userInfo.data.email"
              />
            </div>
          </div>
          <!--Mobile number-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Mobile number
            </p>
            <div class="right-side">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text  fz13 bg-dark2 text-secondary border-0"
                    >+61</span
                  >
                </div>
                <input
                  class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                  type="text"
                  v-model="userInfo.data.phone"
                />
              </div>
            </div>
          </div>

          <!--Address 1-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Address 1
            </p>
            <div class="right-side">
              <input
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                type="text"
                required
                v-model="userInfo.data.addressOne"
              />
            </div>
          </div>

          <!--Address 2-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Address 2
            </p>
            <div class="right-side">
              <input
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                type="text"
                required
                v-model="userInfo.data.addressTwo"
              />
            </div>
          </div>

          <!--Postcode-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Postcode
            </p>
            <div class="right-side">
              <input
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                type="text"
                v-model="userInfo.data.postcode"
              />
            </div>
          </div>

          <div class="mx-3 mt-3">
            <b-alert show v-if="updateInfoSuccessMessage" variant="success">
              {{ updateInfoSuccessMessage }}
            </b-alert>
            <b-alert show v-if="updateInfoErrorMessage" variant="danger">
              {{ updateInfoErrorMessage }}
            </b-alert>
          </div>

          <ul class="list-inline list-unstyled m-0 px-3 py-2">
            <li class="list-inline-item ">
              <button
                :disabled="updating"
                class="btn btn-success bg-success text-uppercase fz13 border-0 br0 py-1"
                type="submit"
              >
                <b-spinner class="mx-1 " small v-if="updating"></b-spinner>
                <span>confirm</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                @click.prevent="getUserInformation"
                class="btn btn-dark bg-dark fz13 border-0 br0 py-1 text-uppercase"
              >
                cancel
              </button>
            </li>
          </ul>

          <hr class="m-0 border-0 bg-dark2" style="height: 2px;" />
        </div>
      </form>

      <!--Change password section-->
      <div class="part" v-if="isEmailAccount">
        <form
          @input.prevent="handleChangePasswordFormDataChange"
          @submit.prevent="changePassword"
          action=""
        >
          <div class="p-2 px-3 d-flex justify-content-between">
            <p class="m-0 ml-3 py-2">CHANGE PASSWORD</p>
          </div>
          <hr class="m-0 border-0 bg-dark2 mb-2" style="height: 2px;" />

          <!--Change password-->
          <div class="d-flex justify-content-between py-1 px-3 fz13">
            <p class="d-flex justify-content-center flex-column m-0">
              Current password
            </p>
            <div class="right-side">
              <input
                :minlength="config.minPasswordLength"
                class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                required
                type="password"
                v-model="oldPassword"
              />
            </div>
          </div>

          <div class="d-flex justify-content-between py-1 px-3 fz13 mb-2">
            <p class="d-flex justify-content-center flex-column m-0">
              New password
            </p>
            <div class="right-side">
              <div class="input-group">
                <input
                  :minlength="config.minPasswordLength"
                  :type="viewPassword ? 'text' : 'password'"
                  class="form-control br0 border-0 bg-dark py-0 fz13 text-secondary"
                  required
                  v-model="newPassword"
                />
                <div class="input-group-append">
                  <button
                    @click.prevent="viewPassword = !viewPassword"
                    class="btn btn-info br0 border-0 bg-dark py-0 fz13 text-secondary"
                    type="button"
                  >
                    <i
                      :class="viewPassword ? 'fa-eye' : 'fa-eye-slash'"
                      class="fa"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mx-3 mt-3">
            <b-alert show v-if="changePasswordSuccessMessage" variant="success">
              {{ changePasswordSuccessMessage }}
            </b-alert>
            <b-alert show v-if="changePasswordErrorMessage" variant="danger">
              {{ changePasswordErrorMessage }}
            </b-alert>
          </div>

          <ul class="list-inline list-unstyled m-0 text-uppercase px-3 py-2">
            <li class="list-inline-item">
              <button
                :disabled="changingPassword"
                class="btn btn-success bg-success fz13 border-0 br0 py-1 text-uppercase"
                type="submit"
              >
                <b-spinner
                  class="mx-1 "
                  small
                  v-if="changingPassword"
                ></b-spinner>
                <span>change password</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                @click.prevent="clearPasswords"
                class="btn btn-dark bg-dark fz13 border-0 br0 py-1 text-uppercase"
                type="button"
              >
                cancel
              </button>
            </li>
          </ul>
          <hr class="m-0 border-0 bg-dark2" style="height: 2px;" />
        </form>
      </div>

      <!--Delete account-->
      <div class="part">
        <div class="p-2 px-3 d-flex justify-content-between">
          <p class="m-0 ml-3 py-2">DEACTIVATE ACCOUNT</p>
        </div>
        <hr class="m-0 border-0 bg-dark2 mb-2" style="height: 2px;" />
        <div class="row m-0 justify-content-between">
          <div class="col-lg-7 col-md-9 py-3 px-3">
            <div class="txt">
              <p class="fz14 text-muted m-0">Deactivate your account</p>
              <p class="fz13 text-white m-0 ">
                Deactivating your account will stop you from receiving alerts.
                You can initiate reactivation process by signing in again.
              </p>
            </div>
          </div>
          <!--Delete account button-->
          <div
            class="col-md-2 col-lg-4 py-3 d-flex justify-content-center flex-column text-right"
          >
            <p class="m-0">
              <span
                class="text-uppercase cursor-pointer text-decoration-line-underline"
                v-b-modal.modal-deactivate
                >Deactivate Account</span
              >
            </p>
          </div>

          <b-modal
            body-text-variant="primary"
            footer-text-variant="primary"
            header-text-variant="light"
            id="modal-deactivate"
            title="Deactivate account?"
          >
            <b-container fluid>
              <p class="text-light">
                Are you sure you want to deactivate your account. You might miss
                important notifications.
              </p>

              <div class=" mt-3">
                <b-alert show v-if="deactivateSuccessMessage" variant="success">
                  {{ deactivateSuccessMessage }}
                </b-alert>
                <b-alert show v-if="deactivateErrorMessage" variant="danger">
                  {{ deactivateErrorMessage }}
                </b-alert>
              </div>
            </b-container>
            <template v-slot:modal-footer>
              <div class="">
                <button
                  @click.prevent="hideModal"
                  class="btn btn-secondary bg-transparent border-0 br0 mx-1 fz14"
                  type="button"
                >
                  Close
                </button>

                <button
                  :disabled="deactivatingAccount"
                  @click.prevent="deactivateAccount"
                  class="btn btn-primary bg-dark2 border-0 br0 fz14"
                  type="submit"
                >
                  <b-spinner
                    class="mx-1 "
                    small
                    v-if="deactivatingAccount"
                  ></b-spinner>
                  <span>Deactivate</span>
                </button>
              </div>
            </template>
          </b-modal>
        </div>
        <hr class="m-0 border-0 bg-dark2" style="height: 2px;" />
      </div>
    </div>
  </div>
</template>
<script>
import { apiUrl, fetchPost, globalLogout } from "@/commons";
import config from "@/config";
import { Auth } from "aws-amplify";

export default {
  name: "AccountInformation",
  data() {
    return {
      updating: false,
      oldPassword: "",
      newPassword: "",
      viewPassword: false,
      changingPassword: false,
      updateInfoErrorMessage: null,
      updateInfoSuccessMessage: null,
      changePasswordSuccessMessage: null,
      changePasswordErrorMessage: null,
      deactivatingAccount: false,
      deactivateSuccessMessage: null,
      deactivateErrorMessage: null,
    };
  },
  computed: {
    userInfo() {
      var user = this.$store.state.user;
      user.ladbrokeId = "123"; // TO-DO
      return user;
    },
    config() {
      return config;
    },
    isEmailAccount() {
      return this.userInfo?.data?.signupProvider?.toLowerCase() === "email";
    },
  },
  methods: {
    handleUserInfoFormDataChange() {
      this.updateInfoErrorMessage = null;
      this.updateInfoSuccessMessage = null;
    },
    handleChangePasswordFormDataChange() {
      this.clearChangePasswordMessages();
    },
    clearChangePasswordMessages() {
      this.changePasswordErrorMessage = null;
      this.changePasswordSuccessMessage = null;
    },
    clearPasswords() {
      this.newPassword = "";
      this.oldPassword = "";
    },
    getUserInformation() {
      this.updateInfoErrorMessage = null;
      this.updateInfoSuccessMessage = null;
      this.$store.dispatch("getUserInfoSecretly");
    },
    hideModal() {
      this.$bvModal.hide("modal-deactivate");
    },
    async handleUpdateUserInformation() {
      this.updating = true;
      this.updateInfoErrorMessage = null;
      this.updateInfoSuccessMessage = null;

      const user = this.userInfo?.data;
      const [err, response] = await fetchPost(`${apiUrl}/users/update-user`, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email ? user.email.toLowerCase() : user.email,
        phone: user.phone,
        postcode: user.postcode,
        username: user.username,
        addressOne: user.addressOne,
        addressTwo: user.addressTwo,
      });
      if (err) {
        this.updateInfoErrorMessage = err;
      } else if (response) {
        if (response.errorNo === 0) {
          this.updateInfoSuccessMessage = response.message;
        } else {
          this.updateInfoErrorMessage = response.message;
        }
      }
      this.updating = false;
    },
    async changePassword() {
      this.changingPassword = true;
      this.changePasswordSuccessMessage = null;
      this.changePasswordErrorMessage = null;

      try {
        const user = await Auth.currentAuthenticatedUser();
        const response = await Auth.changePassword(
          user,
          this.oldPassword,
          this.newPassword
        );
        if (response === "SUCCESS") {
          this.changePasswordSuccessMessage = "Password changed successfully";
        } else {
          this.changePasswordErrorMessage = response;
        }
      } catch (e) {
        if (e.code === "NotAuthorizedException") {
          this.changePasswordErrorMessage =
            "Incorrect old password. Please try again";
        } else {
          this.changePasswordErrorMessage = e.message;
        }
      }
      this.changingPassword = false;
    },
    async deactivateAccount() {
      this.deactivatingAccount = true;
      this.deactivateErrorMessage = null;
      this.deactivateSuccessMessage = null;

      const [err, response] = await fetchPost(`${apiUrl}/users/deactivate`, {});
      if (err) {
        this.deactivateErrorMessage = err;
      } else {
        if (response.errorNo === 0) {
          this.deactivateSuccessMessage = response.message;
          setTimeout(() => {
            this.hideModal();
            globalLogout();
          }, 2000);
        } else {
          this.deactivateErrorMessage = response.message;
        }
      }

      this.deactivatingAccount = false;
    },
  },
};
</script>
<style>
.email-disabled {
  color: #888888 !important;
  cursor: not-allowed;
}
</style>
